
import API from '@/api/api_sign'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Tabbar,
TabbarItem,
Group,
Cell,
Card,XButton
},
data () {
return {
list:[
{
userName:'',
customerNo:'',
id:'1'
}
],
}
},
created(){
this.getList();
},
methods: {
getList(){
API.entlist().then((res)=>{
if (res.code == '000000') {
this.datas = res.data;
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},
gos(id){
this.$router.push(`/contract/${id}`)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/contract.vue